import React from 'react';
import PropTypes from 'prop-types';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

import { Button } from 'core/components/button';
import { useViewAs } from './view-as-context';

import useStyles from './view-as-banner.styles';

const LensBanner = ({ viewAs }) => {
  const classes = useStyles();
  const { agencyName, affinity } = viewAs.subject;
  const agent = agencyName ? `an agent at ${agencyName}` : `an agent with affinity code ${affinity}`;

  return (
    <div className={classes.banner} role="status">
      <VisibilityOutlinedIcon className={classes.icon} aria-hidden="true" />
      <span className={classes.message}>
        You're seeing what {agent} sees. Records aren't filtered to their agency, and actions still run as you.
      </span>
      <Button variant="outlined" color="secondary" size="small" onClick={viewAs.showBranchView}>
        Back to my view
      </Button>
    </div>
  );
};

LensBanner.propTypes = {
  viewAs: PropTypes.object.isRequired
};

// Shown under the top bar while the View as lens is on.
const ViewAsBanner = () => {
  const viewAs = useViewAs();
  return viewAs?.active ? <LensBanner viewAs={viewAs} /> : null;
};

export default ViewAsBanner;
